import { CLAN, PROFILE } from '@/constants/accounts';

const first_name = ['display_name', 'login', 'name'];

const clan_name = ['clan'];

const country = ['country', 'country_id'];

const city = ['city', 'city_id'];

export const FORM_FIELDS_RELATIONS = {
  [PROFILE]: {
    first_name,
    clan_name,
    country,
    city,
  },
  [CLAN]: {
    clan_name,
    country,
    city,
  },
};
